module.exports = __webpack_public_path__ + "img/arrow_down_red_24dp.561c1aca.png";